var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcVideoOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.5 6h9a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2m-4 2a4 4 0 0 1 4-4h9a4 4 0 0 1 3.982 3.619l3.386-1.129A2 2 0 0 1 23.5 8.387v7.226a2 2 0 0 1-2.633 1.897l-3.385-1.129A4 4 0 0 1 13.5 20h-9a4 4 0 0 1-4-4zm17 6.28 4 1.333V8.387l-4 1.334z",
  clipRule: "evenodd"
})));
export default SvgIcVideoOn;